import React, { ReactNode, useState } from 'react';
import { WixPatternsEssentialsOverrides, showToastCompat } from '@wix/bex-core';
import { useEssentials } from '@wix/yoshi-flow-bm/fe-essentials-giza';
import { useComponentLoaded, usePlatformApi } from '@wix/yoshi-flow-bm';
import { CairoProvider } from '../providers';
import { buildCairoEssentials } from './buildCairoEssentials';

export interface WixPatternsGizaProviderProps {
  children?: ReactNode;
  value?: Partial<WixPatternsEssentialsOverrides>;
  localCache?: boolean;
}

/**
 * @deprecated
 * use `WixPatternsGizaProvider`
 */
export function CairoGizaProvider(props: WixPatternsGizaProviderProps) {
  const { children, value: cairoEssentialsOverridesProp, localCache } = props;
  const { showToast, navigateTo, onBeforeUnload, getHostContainer } =
    usePlatformApi();
  const essentials = useEssentials();

  const [wixPatternsEssentialsOverrides] = useState(
    (): Partial<WixPatternsEssentialsOverrides> => ({
      navigateTo,
      getHostContainer,
      showToast: showToastCompat(showToast),
      useAppLoaded: () => {
        useComponentLoaded();
      },
      onBeforeUnload,
      ...cairoEssentialsOverridesProp,
    }),
  );

  const [cairoEssentials] = useState(() =>
    buildCairoEssentials(essentials, {
      overrides: wixPatternsEssentialsOverrides,
    }),
  );

  return (
    <CairoProvider value={cairoEssentials} localCache={localCache}>
      {children}
    </CairoProvider>
  );
}

export const WixPatternsGizaProvider = CairoGizaProvider;
